//File: src/App.jsx

/*
 * Critical Design
 * Do not modify this section without explicit permission
 * 
 * Main application component that handles routing and layout.
 * - Uses React Router for navigation
 * - Implements responsive layout with overflow handling
 * - Conditionally renders DevTools in development
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import { LayoutProvider } from './contexts/LayoutContext';
import { AuthProvider } from './contexts/AuthContext';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import ForgotPassword from './pages/ForgotPassword';
import AirportList from './components/AirportList';
import AirportDetail from './pages/AirportDetail';
import Users from './pages/Users';
import DevTools from './components/DevTools';
import ReloadPrompt from './components/ReloadPrompt';

// Protected route wrapper component
const ProtectedRoute = ({ children }) => {
  const { currentUser } = useAuth();
  
  if (!currentUser) {
    return <Navigate to="/login" />;
  }
  
  return children;
};

// Editor route wrapper component
const EditorRoute = ({ children }) => {
  const { currentUser } = useAuth();
  
  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  if (!currentUser.profile?.isEditor) {
    return <Navigate to="/" />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <LayoutProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route 
            path="/" 
            element={
              <ProtectedRoute>
                <AirportList />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/airport/:id" 
            element={
              <ProtectedRoute>
                <AirportDetail />
              </ProtectedRoute>
            } 
          />
          <Route
            path="/users"
            element={
              <EditorRoute>
                <Users />
              </EditorRoute>
            }
          />
        </Routes>
      </LayoutProvider>
      {import.meta.env.DEV && <DevTools />}
      <ReloadPrompt />
    </AuthProvider>
  );
}

export default App;
